import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/core-connect/headerRightBg.png';
import headerRightBg375 from '../images/core-connect/headerRightBg375.png';
import ManDeskAppsCircuit from '../images/core-connect/ManDeskAppsCircuit.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import CloudNodes from '../images/core-connect/CloudNodes.svg';
import DocumentsPen from '../images/core-connect/DocumentsPen.svg';
import Atom from '../images/core-connect/Atom.svg';
import BoxesGearsHoses from '../images/core-connect/BoxesGearsHoses.svg';
import WantToSeeHow from '../components/WantToSeeHow';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const CoreConnectHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `80px`, paddingBottom: `40px`}}>
		<h1>CoreConnect</h1>
		<p>End-to-end data flow<br />from application to servicing</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 90%;
		margin-bottom: 3em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-bottom: 3em;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const ManDeskAppsCircuitFigure =
	<HeaderBottomContentFigure>
		<ManDeskAppsCircuit alt='Man at desk looking at connected apps' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const CoreConnectPage = (props: any) => {
	return (
	<Layout
		headerSplashBg={headerRightBg}
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPosition={'right top'}
		headerSplashBgPositionLarge={'center -80px'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={ManDeskAppsCircuitFigure}
		headerContentClass={'product'}
		headerContent={CoreConnectHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='CoreConnect - Core Processor APIs'
		metaDescription={'Integrate with your core processor for a streamlined data pipeline to quickly create accounts and get your customers credit faster.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'440px'}
		BodyClass={'CoreConnect'}
	>
		<ProblemSolution
			problem={"Manual onboarding to core processors requires repetitive data entry that is prone to human error and delays customers' access to credit."}
			solution={"CoreConnect's core processor APIs cut down time spent on data entry and curb human error with end-to-end data flow."}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3498d3'}

			leftIcon = {<CloudNodes alt='cloud nodes icon' style={{margin: `0 0`}} />}
			leftHeading = {'Batch or real-time\naccount uploads'}
			leftText={'Reduce human error by eliminating repeat data entry.'}

			middleIcon = {<DocumentsPen alt='documents and pen icon' style={{margin: `0 0`}} />}
			middleHeading = {'Consumer and\nbusiness accounts'}
			middleText = {'Diversify your loan portfolio with support for multiple loan types.'}

			rightIcon = {<Atom alt='Atom icon' style={{margin: `0px 0`}} />}
			rightHeading = {'Digital ACH\nprocessing'}
			rightText = {'Increase revenue by providing customers with credit faster.'}
		/>
		<div className='centeredWrapper'>
			<Section className='strategic-fraud row row-flush centered'>
				<article className='col-12 col-md-6 right-on-desktop'>
					<div className='product text-box'>
						<header>
							<h2>Free yourself from the burden of data entry</h2>
						</header>
						<p>It’s time to open the doors to a new standard in loan origination and free yourself from the burden of data entry to the core.</p><p>CoreConnect helps you reduce friction and operational costs through a streamlined system-to-system data flow. Seamlessly integrate with your desired core processor, so you can easily create new accounts while leveraging existing data and transaction history.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6 left-on-desktop' id='BoxesGearsHoses'>
					<BoxesGearsHoses alt='Connected Boxes, Gears and Circuits' />
				</figure>
			</Section>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default CoreConnectPage;
